import styled from 'styled-components';

const NavigationMenuWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 38px;
  padding-top: 10px;
`;

export default NavigationMenuWrapper;
